import { render, staticRenderFns } from "./InformacionGeneral.vue?vue&type=template&id=8547e04a"
import script from "./InformacionGeneral.vue?vue&type=script&lang=js"
export * from "./InformacionGeneral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports